import PropTypes from "prop-types";

import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import FormNewsletter from "components/molecules/FormNewsletter";
import Banner from "components/organisms/Banner";
import WhatPartnerLove from "components/organisms/WhatPartnerLove";

import MembershipTier from "./MembershipTier";

const Component = ({ data }) => {
  return (
    <>
      <section>
        <Banner
          minHeightBanner="banner-min-h-569"
          title="Partner with<br/> BBCIncorp"
          description={data?.banner?.description}
          titleProps={{
            textColor: "banner-title-default-color bg-bbc-gradient-liner1",
            className: "banner-default-title capitalize lg:tracking-[0.25px]",
          }}
          bgColor="bg-bbc-useful-links"
          breadcrumbs={data?.banner?.breadcrumbs}
          leftClassName="lg:col-7"
          rightClassName="lg:col-5"
          rightContent={
            <Img
              className="max-w-full object-cover object-center"
              src="/assets/images/common/become-our-partner/banner-partner.png"
              width={622}
              height={436}
              alt="banner"
              priority={true}
              wrapper={{
                className: "bbc-banner-image-bottom-0",
              }}
            />
          }
        />
      </section>
      <section>
        <WhatPartnerLove
          title={data?.advantage?.title}
          subTitle={data?.advantage?.subTitle}
          image={data?.advantage?.image}
          data={data?.advantage?.data}
        />
      </section>
      <section>
        <div className="container">
          <Title
            text="The one partner that moves the needle"
            className="title-h2 mb-6 text-center text-bbc-brand-800 lg:mb-10"
          />
          <div className="row gap-y-6">
            <div className="col-12 flex flex-col lg:col-6">
              <div className="mb-6 lg:order-2 lg:mb-0 lg:mt-10">
                <Title
                  as="h4"
                  text="A centralized platform to streamline your management effort"
                  className="mb-4 text-lg font-medium text-bbc-brand-700 lg:mb-6 lg:min-h-[72px] lg:text-2xl lg:font-semibold lg:leading-9"
                />
                <p>
                  Too busy to handle all legal stuff for your clients’
                  companies? Our management portal was designed for just that.
                  Set it up and keep them all compliant in one place.
                </p>
              </div>
              <Img
                src="/assets/images/common/become-our-partner/section_2_1-partner.png"
                alt="management portal"
                width={540}
                height={304}
              />
            </div>
            <div className="col-12 flex flex-col lg:col-6">
              <div className="mb-6 lg:order-2 lg:mb-0 lg:mt-10">
                <Title
                  as="h4"
                  text="Supporting marketing materials"
                  className="mb-4 text-lg font-medium text-bbc-brand-700 lg:mb-6 lg:min-h-[72px] lg:text-2xl lg:font-semibold lg:leading-9"
                />
                <p>
                  Take advantage of our country profiles and service brochures
                  to outreach new clients. Make them feel more confident to
                  enlist your services.
                </p>
              </div>
              <Img
                src="/assets/images/offshore/become-our-partner/section_2_2-offshore-partner.png"
                alt="partner program brochure"
                width={2160}
                height={1216}
              />
            </div>
          </div>
        </div>
      </section>
      <section className="relative py-10 px-[15px] lg:py-20">
        <div className="container relative z-10 text-center">
          <Title
            text="How To Become Our Partner"
            className="title-h2 mb-6 text-white lg:mb-10"
          />
          <p className="text-lg font-medium text-white">
            If you intend to use our incorporation service for more than 5
            companies, then you are welcomed to join our programme.
          </p>
        </div>
        <Img
          src="/assets/images/common/required-documents.png"
          width={1920}
          height={737}
          className="h-full w-full"
          wrapper={{ className: "absolute top-0 left-0 w-full h-full z-0" }}
          alt="section bg"
        />
      </section>
      <section>
        <div className="container">
          <div className="row justify-center">
            <div className="col-12 lg:col-8">
              <Title
                text="Enjoy Great Benefit With Different Membership Tiers"
                className="mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800 lg:text-4xl lg:leading-[50px] lg:text-bbc-brand-700"
              />
              <p className="mb-6 text-center">
                We offer multi-tiered discounts for clients with these
                milestones
              </p>
            </div>
            <MembershipTier data={data} />
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          {/* <Toast>
            <PartnerForm bgColor="bg-bbc-gradient-14" />
          </Toast> */}
          <FormNewsletter
            title="Want To Find Out More About Our Partner Programme"
            description="Just leave us your email, and we will respond with more details"
            bgColor="bg-bbc-gradient-14"
            apiLink="api/portal/contact_form/partner"
            triggerName="Partner form"
            buttonText="Submit"
          />
        </div>
      </section>
    </>
  );
};

export default Component;

Component.propTypes = {
  data: PropTypes.object,
};

Component.defaultProps = {
  data: {},
};
